
// Accordion

/* global $biro_body */


jQuery(function($) {

	// Control click
	$biro_body.on( 'click', '.biro-accordion-control', function( e ) {

		// Init
		var $el    = $( this );
		var $panel = $( '#' + $el.attr( 'aria-controls' ) );

		if ( ! $panel.is( ':visible' ) ) {

			$panel.slideDown(
				200,
				function () {
					$panel.focus();
				}
			);
			$el.attr( 'aria-expanded', 'true' );

		} else {

			$panel.slideUp( 100 );
			$el.attr( 'aria-expanded', 'false' );

		}

	});

});